import { DescribeProperty } from '../../common';

export class AnnotationEntryResponse {
  @DescribeProperty({
    description: 'The ID of created annotation',
    example: '123e4567-e89b-12d3-a456-426614174000',
    type: 'string',
    format: 'uuid',
  })
  id: string;

  @DescribeProperty({
    description: `The ID of annotation's project`,
    example: '123e4567-e89b-12d3-a456-426614174000',
    type: 'string',
    format: 'uuid',
  })
  projectEntryId: string;

  @DescribeProperty({
    description: `The ID of scene entity that annotation is attached to`,
    example: 'd123e4567_426614174000',
    type: 'string',
  })
  sceneEntityId: string | null;

  @DescribeProperty({
    description: `The CSS color of annotation's marker`,
    example: '#ffffff',
    type: 'string',
  })
  markerColor: string | null;

  @DescribeProperty({
    description: `The ID of annotation's project`,
    example: '123e4567-e89b-12d3-a456-426614174000',
    type: 'string',
  })
  glyph: string | null;

  @DescribeProperty({
    description: `The title of annotation`,
    example: 'Example annotation title',
    type: 'string',
  })
  title: string | null;

  @DescribeProperty({
    description: `The description of annotation`,
    example: 'Example annotation description',
    type: 'string',
  })
  description: string | null;

  @DescribeProperty({
    description: 'Annotation X rotation in the scene',
    type: 'number',
  })
  positionX: number | null;

  @DescribeProperty({
    description: 'Annotation Y position in the scene',
    type: 'number',
  })
  positionY: number | null;

  @DescribeProperty({
    description: 'Annotation Z position in the scene',
    type: 'number',
  })
  positionZ: number | null;

  @DescribeProperty({ description: 'Updated at', type: 'string', format: 'date-time' })
  updatedAt: Date;

  @DescribeProperty({ description: 'Created at', type: 'string', format: 'date-time' })
  createdAt: Date;
}
